var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBankIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.14844 9.39016V17.3902M9.64844 9.39016V17.3902M14.6484 9.39016V17.3902M19.1484 9.39016V17.3902M3.14844 18.9902L3.14844 19.7902C3.14844 20.3502 3.14844 20.6302 3.25743 20.8441C3.3533 21.0323 3.50628 21.1853 3.69445 21.2812C3.90836 21.3902 4.18838 21.3902 4.74844 21.3902H19.5484C20.1085 21.3902 20.3885 21.3902 20.6024 21.2812C20.7906 21.1853 20.9436 21.0323 21.0394 20.8441C21.1484 20.6302 21.1484 20.3502 21.1484 19.7902V18.9902C21.1484 18.4301 21.1484 18.1501 21.0394 17.9362C20.9436 17.748 20.7906 17.595 20.6024 17.4992C20.3885 17.3902 20.1085 17.3902 19.5484 17.3902H4.74844C4.18839 17.3902 3.90836 17.3902 3.69445 17.4992C3.50629 17.595 3.3533 17.748 3.25743 17.9362C3.14844 18.1501 3.14844 18.4301 3.14844 18.9902ZM11.8013 3.46729L4.40135 5.11173C3.95429 5.21108 3.73076 5.26075 3.5639 5.38096C3.41673 5.48699 3.30116 5.63105 3.22959 5.79772C3.14844 5.98668 3.14844 6.21566 3.14844 6.67363L3.14844 7.79016C3.14844 8.35021 3.14844 8.63023 3.25743 8.84415C3.3533 9.03231 3.50628 9.18529 3.69445 9.28116C3.90836 9.39016 4.18838 9.39016 4.74844 9.39016H19.5484C20.1085 9.39016 20.3885 9.39016 20.6024 9.28116C20.7906 9.18529 20.9436 9.03231 21.0394 8.84415C21.1484 8.63024 21.1484 8.35021 21.1484 7.79016V6.67363C21.1484 6.21567 21.1484 5.98668 21.0673 5.79772C20.9957 5.63105 20.8801 5.48699 20.733 5.38096C20.5661 5.26075 20.3426 5.21108 19.8955 5.11173L12.4955 3.46729C12.366 3.4385 12.3012 3.42411 12.2358 3.41837C12.1777 3.41328 12.1192 3.41328 12.0611 3.41837C11.9956 3.42411 11.9309 3.4385 11.8013 3.46729Z",
    stroke: "url(#paint0_linear_6202_2979)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6202_2979",
    x1: 12.1484,
    y1: 3.41455,
    x2: 12.1484,
    y2: 21.3902,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#337388"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#33B17B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankIcon);
export default __webpack_public_path__ + "static/media/bank-icon.d187c652367e8e0cd5aec5d2263c4794.svg";
export { ForwardRef as ReactComponent };